import BigNumber from "bignumber.js";

export function addThousandSeparator(input: number): string {
  if (input) {
    const parts = input.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else return "";
}
export function addThousandSeparatorToStr(input: string): string {
  if (input) {
    const parts = input.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else return "";
}

export function removeThousandSeparator(input: number): number {
  if (input) return parseInt(input.toString().replace(",", ""));
  else throw "Invalid input";
}

export function removeThousandSeparatorFromString(input: string): number {
  if (input) return parseInt(input.replace(",", ""));
  else throw "Invalid input";
}

export function addThousandSeparatorWithDP(input: number, dp: number): string {
  if (typeof input === "number" && typeof dp === "number" && !isNaN(input)) {
    const parts = input.toFixed(dp).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else return "";
}

export function formatAsThousands(input: number): string {
  if (input) return (input / 1000).toFixed(1) + "K";
  else return "";
}

export function formatAsMillions(input: number): string {
  if (input) return (input / 1000000).toFixed(1) + "M";
  else return "";
}

export function getChangeInFraction(prev: number, curr: number): number {
  // division by zero
  if (prev === 0) return 0;

  return (curr - prev) / prev;
}

export function formatAsDecimalString(
  input: number,
  decimalPoint: number = 0
): string {
  // invalid params
  if (!input) return "0";
  if (decimalPoint < 0) return "0";

  return addThousandSeparatorToStr(input.toFixed(decimalPoint));
}

export function formatAsDecimalStringNoRounded(
  input: number,
  decimalPoint: number = 0
): string {
  // invalid params
  if (
    input === null ||
    input === undefined ||
    typeof input !== "number" ||
    isNaN(input)
  ) {
    return "0";
  }
  if (decimalPoint < 0) return "0";

  return addThousandSeparatorToStr(toFixedNoRounded(input, decimalPoint));
}

export function toFixedNoRounded(input: number, fixed: number = 2): string {
  const re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  const data = input.toString().match(re);
  return data ? Number(data[0]).toFixed(fixed) : input.toFixed(fixed);
}

/**
 * Rounds a number up to two decimal places.
 * @param num The number to round up.
 * @returns The rounded number.
 */
export function roundUpToTwoDP(num: number) {
  return Math.ceil(num * 100) / 100;
}

/**
 * Rounds a number down to two decimal places.
 * @param num The number to round down.
 * @returns The rounded number.
 */
export function roundDownToTwoDP(num: number): number {
  return Math.floor(num * 100) / 100;
}

export function formatBNInvestmentAmountWithDP(
  value: string | number | undefined,
  decimalPlaces: number = 2
): string {
  if (value === undefined || value === null || value === "") {
    return "0.00";
  }

  const bnValue = new BigNumber(value);

  if (bnValue.isNaN()) {
    return "0.00";
  }

  // Format to specified decimal places
  const formatted = bnValue.toFixed(decimalPlaces, BigNumber.ROUND_DOWN);

  // Add thousand separators
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Helper function to format numeric string into 2 decimal places
 * @param numStr
 */
export function formatNumStrToTwoDecimalsNumStr(
  numStr: string,
  rounded: boolean = true
): string {
  if (typeof numStr !== "string") {
    throw new Error("Input must be a string");
  }

  return new BigNumber(numStr).toFixed(
    2,
    rounded ? BigNumber.ROUND_HALF_UP : BigNumber.ROUND_DOWN
  );
}

/**
 * Helper function to return safe price string
 * Note pricing value is rounded down to 2dp by default
 * @param price
 * @example
 * null => "-"
 * "10.0000" => "10.00"
 */
export function renderPrice(price: string | null): string {
  if (price === null) return "-";
  if (BigNumber(price).isZero()) return "-";
  return addThousandSeparatorToStr(
    formatNumStrToTwoDecimalsNumStr(price, false)
  );
}
